export const getUserRole = (code) => {
  switch (code) {
    case 'SYSTEM':
      return '시스템관리자';
    case 'ADMIN':
      return '통합관리자';
    case 'MANAGER':
      return '충전관리자';
    case 'CHARGER':
      return '충전원';
    case 'DELIVERER':
      return '배송원';
    case 'SALES':
      return '영업사원';
    case 'CUSTOMER_MANAGER':
      return '고객사 담당자';
    case 'CUSTOMER_USER':
      return '고객사 일반사용자';
    default:
      return code;
  }
};

export const getOrderDisplayNo = (order) => {
  if (!order) return '-';
  return order.orderNo || order.originNo || '-';
};

export const getOrderStatus = (code) => {
  switch (code) {
    case 'RECEIVED':
      return '주문접수';
    case 'CHARGING':
      return '준비중';
    case 'SHIPPING':
      return '배송중';
    case 'DELIVERED':
      return '배송완료';
    case 'CANCELED':
      return '주문취소';
    default:
      return code;
  }
};

export const getPaymentMethod = (code) => {
  switch (code) {
    case 'CARD_ONSITE':
      return '카드결제 현장';
    case 'CARD_ONLINE':
      return '카드결제 온라인';
    case 'TAX_INVOICE':
      return '세금계산서';
    case 'FREE':
      return '무상';
    default:
      return code;
  }
};

export const getCustomerStatus = (code) => {
  switch (code) {
    case 'ACTIVE':
      return '활성';
    case 'INACTIVE':
      return '비활성';
    default:
      return code;
  }
};

export const getReclaimStatus = (code) => {
  switch (code) {
    case 'RECEIVED':
      return '회수접수';
    case 'SHIPPING':
      return '회수중';
    case 'RECLAIMED':
      return '회수완료';
    default:
      return code;
  }
};

export const getTankUseStatus = (code) => {
  switch (code) {
    case 'DRAFT':
      return '임시';
    case 'READY':
      return '준비';
    case 'INUSE':
      return '사용';
    case 'RETIRED':
      return '폐기';
    case 'INSPECTING':
      return '검사';
    case 'RECALL':
      return '리콜';
    case 'DISABLED':
      return '사용중지';
    default:
      return code;
  }
};

export const getTankChargeStatus = (code) => {
  switch (code) {
    case 'CHARGED':
      return '충전';
    case 'UNCHARGED':
      return '미충전';
    default:
      return code;
  }
};

export const getShippingType = (code) => {
  switch (code) {
    case 'OUTGOING':
      return '출고';
    case 'INCOMING':
      return '입고';
    case 'DELIVERED':
      return '완료';
    default:
      return code;
  }
};
